import { useState } from 'react';
import { useUpdateEffect } from './useUpdateEffect';
import automobyApi from '../Api';
 
export const useMessage = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/message/list", filter)
      setItems(response.data.messages);
      setTotal(response.data.total);
      return response.data.messages
    } catch (error) { 
      console.error("error:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/message/all", requestData)
      setItems(response.data.messages);
      setTotal(response.data.total);
      return response.data.messages
    } catch (error) {

      console.error("error:" + error);
    }
  }

  const add = (mobile, text) => {
    return new Promise(async (resolve, reject) => {
      try {
        const msg = {
          text: text,
          mobile: mobile, 
        };
  
        const response = await automobyApi.post(`/message/create`, msg);

        fetchList();
        resolve(response.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }
  

  const search = async (message, count) => {
    try {
      const requestData = {
        message: message,
        count: count,
      };

      const response = await automobyApi.post("/message/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/message/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          message_id: id
        };
        const response = await automobyApi.post(`/message/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const updateLocal = async (message) => {
    setItems(items.map(item =>
      item.id === message.id ? message : item
    ));
  }
 

  const messageService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { messageService };
}